import {FC} from 'react'
import Chart from 'react-apexcharts';
import {ID} from '@/_metronic/helpers'
import {useState, useEffect} from 'react'
import {SourceData} from '../core/_models'
import {getSourcesRepartition} from '../core/_requests'

type Props = {
  userId?: ID
  from: Date 
  to?: Date,
  height: number
}
const TrxStatusChart: FC<Props> = ({userId, from, to, height}) => {
  const [data, setData] = useState<Array<SourceData>|undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const load = async () => {
      setIsLoading(true)
      try {
        const res = await getSourcesRepartition(from, to, userId)
        setData(res||[])

      } catch (e: any) {
        console.log(e)
      } finally {
      setIsLoading(false)
      }
    }
    load()
  }, [userId, from, to])
  
  if (isLoading) {
    return (
      <div
        className="align-items-center d-grid text-center"
        style={{minHeight: `${height}px`}}
      >
        <span>
          <i className='spinner-border fs-5x'></i>
        </span>
        
      </div>
    )
  }

  if (data === undefined || data.length === 0) {
    return (
      <div
        className="align-items-center d-grid text-center"
        style={{minHeight: `${height}px`}}
      >
        <span>
          No data
        </span>
      </div>
    )
  }


  const series = (data || []).map((d) => d.clicks)
  const max = (data || []).reduce((acc, curr) => acc + curr.clicks, 0)
  const options = {
    chart: {
      id: 'sources-chart',
      toolbar: { show: false },
      zoom: { enabled: false },
      sparkline: {
        enabled: true,
      },
    },
    labels: (data || []).map((d) => d.domain),
    legend: {
      show: false
    },
  }

  return (
    <div className="row align-items-center mx-0 w-100">
      <div className="col-6 px-0">
        <div className="d-flex flex-column content-justify-center">
          <span className="card-label fw-bold fs-3 mb-10">Click sources</span>
          {(data || []).map((d: SourceData, i: number) => {
            return (
              <div key={`status-${i}`} className="d-flex fs-6 fw-semibold align-items-center">
                <div className={`bullet bg-secondary me-3`} ></div>
                <div className="fs-5 fw-bold text-gray-600 me-5">
                  {d.domain}
                </div>
                <div className="ms-auto fw-bolder text-gray-700 text-end">
                  {(d.clicks * 100 / max).toFixed(2)}%
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div className="col-6 d-flex justify-content-end px-0">
        <Chart options={options} series={series} type="donut" height={height} />
      </div>
    </div>
  )
}

export default TrxStatusChart
